var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartConvo = function SvgStartConvo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 68,
    viewBox: "0 0 77 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5964 27.0454H39.7765C37.8103 27.0454 36.5361 29.1109 37.407 30.8737C39.2775 34.6601 43.1775 37.2645 47.6865 37.2645C52.1955 37.2645 56.0956 34.6601 57.9661 30.8737C58.8369 29.1109 57.5625 27.0454 55.5964 27.0454Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0598 19.4343C33.0598 16.8413 35.1619 14.7393 37.7548 14.7393C40.3478 14.7393 42.4498 16.8413 42.4498 19.4343",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3129 19.4343C62.3129 16.8413 60.2108 14.7393 57.6179 14.7393C55.0249 14.7393 52.9229 16.8413 52.9229 19.4343",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4607 55.7703H47.8325C49.2299 55.7703 50.5548 55.4445 51.736 54.8666V49.2358C51.736 47.8496 50.6121 46.7259 49.226 46.7259H29.0364C24.1188 46.7259 20.0953 42.7025 20.0953 37.7849V10.7236H10.5323C5.61474 10.7236 1.59131 14.7471 1.59131 19.6647V46.8294C1.59131 51.747 5.61474 55.7704 10.5323 55.7704H13.1238C14.0287 55.7704 14.8851 56.1792 15.4543 56.8825L22.6735 65.8052C23.4938 66.8192 25.133 66.239 25.133 64.9347V58.2804C25.133 56.8941 26.2567 55.7704 27.643 55.7704H34.2714",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2774 20.9965V10.6202C75.2774 5.70263 71.254 1.6792 66.3364 1.6792H29.0363C24.1186 1.6792 20.0952 5.70263 20.0952 10.6202V37.7849C20.0952 42.7024 24.1186 46.726 29.0363 46.726H49.2258C50.612 46.726 51.7357 47.8498 51.7357 49.2359V55.8903C51.7357 57.1946 53.3749 57.7746 54.1953 56.7608L61.4145 47.8383C61.9835 47.1349 62.8401 46.7261 63.7449 46.7261H66.3364C71.254 46.7261 75.2774 42.7027 75.2774 37.7851V26.1858",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgStartConvo;